import React from "react"

import Image from "@components/Image/Image"
import Link from "@components/Link"
import { AspectRatio, Box, Button, Heading, Text } from "@chakra-ui/react"
import { ContentBoxDesktop } from "./Styles"
import { HeroSlideProps } from "./Hero"

const HeroSlideDesktop = ({ slide, handleTrackingClick }: HeroSlideProps) => {
  const hasLink = slide?.externalLink ? slide?.externalLink : slide.link?.url
  const hasContent = slide.title || slide.content

  const image = (
    <Image
      src={slide?.image?.desktop?.src}
      // style={{ display: "none" }}
      // onLoad={e => (e.target.style.display = "block")}
      loading="eager"
      alt={slide?.image?.desktop?.alt}
      borderRadius="sm"
      width={hasContent && "full"}
      height={hasContent && "full"}
    />
  )

  // const preload = <link rel="preload" href={slide.image.src} as="image" />
  const preload = null

  const content = hasContent ? (
    <Box position="relative">
      {slide?.image?.dimensions?.aspectRatio ? <AspectRatio ratio={slide?.image?.dimensions?.aspectRatio}>{image}</AspectRatio> : image}
      <ContentBoxDesktop>
        <Box>
          <Heading size="h2" color="white">
            {slide.title}
          </Heading>
          <Text size="lg" color="white">
            {slide.content}
          </Text>
        </Box>
        {hasLink && <Button variant="blue">{slide.link.title}</Button>}
      </ContentBoxDesktop>
    </Box>
  ) : slide?.image?.dimensions?.aspectRatio ? (
    <AspectRatio ratio={slide?.image?.dimensions?.aspectRatio}>{image}</AspectRatio>
  ) : (
    image
  )

  return (
    <>
      {preload}
      {hasLink ? (
        <Link to={hasLink} onClick={handleTrackingClick}>
          {content}
        </Link>
      ) : (
        content
      )}
    </>
  )
}

export default React.memo(HeroSlideDesktop)
